import React from 'react';
import { inject, observer } from 'mobx-react';
import uniqueId from 'lodash/uniqueId';
import {
  Steps, Table, Form, Input, Button,
  Row, Col, Select, Timeline, message,
  Modal,
} from 'antd';
import { toJS } from 'mobx';
import Guys from './Guys';

const Step = Steps.Step;
const ButtonGroup = Button.Group;
const FormItem = Form.Item;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    lastPrefixCls: 'dev',
    prefixCls: 'dev-apply-right'
  }
  getGuysColumns = (canEdit) => {
    const columns = [
      { title: "姓名", key: "m_name", dataIndex: "m_name", width: '25%' },
      {
        title: '类型', key: 'm_role', width: '50%',
        render: (text, record) => {
          if (record.m_softrole === "owner") { return "创建者"; }
          if (record.m_role === "管理员") { return "管理员"; }
          if (!canEdit) { return record.roleName; }
          return (
            <Select size="small" value={record.m_role} style={{ width: '100%' }}
              onChange={(value) => this.onEdit(record, 'm_role', value)}>
              <Select.Option value="actor">会员</Select.Option>
              <Select.Option value="developer">开发者</Select.Option>
            </Select>
          );
        }
      }
    ];
    if (canEdit) {
      columns.push({
        title: "",
        render: (text, record) => {
          return record.m_softrole !== 'owner' ? <Button type="ghost" size="small"
            shape="circle-outline" icon="cross"
            onClick={() => this.onRemoveGuy(record.m_id)} /> : ""
        }
      })
    }
    return columns;
  }
  onEdit = (record, key, value) => {
    const { devStore: { member, setMobxState } } = this.props;
    const result = toJS(member).map(v => {
      if (record.m_id === v.m_id) {
        v[key] = value;
      }
      return v;
    });
    setMobxState({ member: result });
  }
  onRemoveGuy = (id) => {
    const { devStore: { member, setMobxState } } = this.props;
    const result = toJS(member).filter(v => v.m_id !== id);
    setMobxState({ member: result });
  }
  openGuys = () => {
    const { devStore: { setMobxState } } = this.props;
    setMobxState({ guysVisible: true });
  }
  getLicense = () => {
    const { form, devStore: { getLicense, messageConfig } } = this.props;
    const { getFieldValue } = form;
    const c_name = getFieldValue("c_name");
    const license = getFieldValue("license");
    if (!c_name || c_name === '') {
      return;
    }
    if (!/^[a-zA-Z0-9]{32}$/.test(license)) {
      messageConfig();
      message.error('license格式有误');
      return;
    }
    getLicense({ c_name, license });
  }
  render() {
    const {
      lastPrefixCls, prefixCls, form,
      devStore: { currentStatus, member, logger, initMember, setMobxState, saveGuys,
        licenseVisible, licenseData, },
    } = this.props;
    const steps = [
      { title: '创建应用', description: '获取要开发的应用的唯一标识' },
      { title: '发布应用', description: '提交发布文件及相关信息' },
      { title: '平台审核', description: '审核发布文件及相关信息' },
      { title: '成功发布', description: '开放给用户申请' },
      { title: '触发新版', description: '已触发新版本，此版本归档' },
    ];
    const { getFieldProps } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    }
    let isOwner = false;
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    if (!!localStorage.me) {
      toJS(member) && toJS(member).forEach(mem => {
        if (mem.m_softrole === 'owner' && mem.m_id === me.member.m_id) {
          isOwner = true;
        }
      });
    }
    const canEditCandidates = me.role === 'admin' || isOwner;
    return (
      <div className={`${prefixCls}`}>
        <div className={`${lastPrefixCls}-right-con`}>
          <div className={`${lastPrefixCls}-right-con-header`}>应用开发过程</div>
          <div className={`${prefixCls}-body`}>
            <Steps size="small" direction="vertical" current={parseInt(currentStatus, 10)}>
              {
                steps.map((s, i) => <Step key={`AppDevProcess_${i}`} title={s.title} description={s.description} />)
              }
            </Steps>
          </div>
        </div>
        <div className={`${lastPrefixCls}-right-con`}>
          <div className={`${lastPrefixCls}-right-con-header`}>
            参与者
            <div className={`${lastPrefixCls}-right-con-header-extraBtn`}>
              {
                canEditCandidates && (<ButtonGroup>
                  <Button size="small" onClick={this.openGuys}>添加</Button>
                  <Button size="small" onClick={() => setMobxState({ member: toJS(initMember) })}>重置</Button>
                  <Button size="small" type="primary" onClick={saveGuys}>保存</Button>
                </ButtonGroup>)
              }
            </div>
          </div>
          <div className={`${prefixCls}-body`}>
            <Table size="small" rowKey="m_id" columns={this.getGuysColumns(canEditCandidates)} dataSource={toJS(member)} />
          </div>
        </div>
        <div className={`${lastPrefixCls}-right-con`}>
          <div className={`${lastPrefixCls}-right-con-header`}>应用开发授权申请</div>
          <div className={`${prefixCls}-body`}>
            <Form>
              <FormItem label="授权用户：" {...formItemLayout} style={{ marginBottom: 10 }}>
                <Input {...getFieldProps('c_name', {
                  // initialValue: toJS(license).dl_cname,
                  // rules: [{ required: true, message: '此选项必填，不能为空' }]
                })} />
              </FormItem>
              <FormItem label="标识码：" {...formItemLayout} style={{ marginBottom: 10 }}>
                <Input {...getFieldProps('license', {
                  // initialValue: toJS(license).dl_license,
                  // rules: [{ required: true, message: '此选项必填，不能为空' }]
                })} />
              </FormItem>
            </Form>
            <Row>
              <Col span={18} offset={6}>
                <Button style={{ marginRight: 20 }} onClick={this.getLicense} type="primary">获取</Button>
              </Col>
            </Row>
          </div>
        </div>
        {
          currentStatus !== 0 && (
            <div className={`${lastPrefixCls}-right-con`}>
              <div className={`${lastPrefixCls}-right-con-header`}>流转记录</div>
              <div className={`${prefixCls}-body`}>
                <Timeline>
                  {
                    toJS(logger) && toJS(logger).map((data) => (<Timeline.Item key={`logger_${uniqueId()}`}>
                      <p>{data.opName}</p>
                      <p>{data.opDesc}</p>
                      <p>{data.opusername} {data.opDatetime}</p>
                    </Timeline.Item>))
                  }
                </Timeline>
              </div>
            </div>
          )
        }
        <Guys />
        <Modal title="应用开发授权" visible={licenseVisible} className={`${prefixCls}-license`}
          onCancel={() => setMobxState({ licenseVisible: false })}
          footer={(<Button onClick={() => setMobxState({ licenseVisible: false })}>返回</Button>)}>
          <Row className={`${prefixCls}-license-row`}>
            <Col span={4} offset={1} className={`${prefixCls}-license-label`}>license: </Col>
            <Col span={18}>{toJS(licenseData)['4key']}</Col>
          </Row>
          <Row className={`${prefixCls}-license-row`}>
            <Col span={4} offset={1} className={`${prefixCls}-license-label`}>下载地址: </Col>
            <Col span={18}>
              {
                toJS(licenseData).url4All && (<div>
                  <a href={toJS(licenseData).url4All} target="_blank">完整（含EC客户端、应用包、授权文件）</a>
                </div>)
              }
              {
                toJS(licenseData).url4App && (<div>
                  <a href={toJS(licenseData).url4App} target="_blank">应用（含应用包、授权文件）</a>
                </div>)
              }
              {
                toJS(licenseData).url4Key && (<div>
                  <a href={toJS(licenseData).url4Key} target="_blank">授权（含授权文件）</a>
                </div>)
              }
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Right.js